import { Routes, Route } from 'react-router-dom';

import { PrivateRoutes } from './Private';

import { Home } from '../components/pages/Home';
import { Stages } from '../components/pages/Stages';
import { StageDetails } from '../components/pages/StageDetails';
import { Chat } from '../components/pages/Chat';
import { Analysis } from '../components/pages/analysis/Index';
import { CompleteData } from '../components/pages/CompleteData';

export const NavigationRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />

            <Route element={<PrivateRoutes />}>
                <Route path="/simulation/:simulationKey/stages" element={<Stages />} />
                <Route path="/simulation/:simulationKey/stages/:stageKey/details/:action" element={<StageDetails />} />
                <Route path="/simulation/:simulationKey/stages/:stageKey/conversation/:conversationId" element={<Chat />} />
                <Route path="/simulation/:simulationKey/analysis" element={<Analysis />} />
                <Route path="/reports/e529f5f0-87bd-42f7-8715-39547824e55e" element={<CompleteData />} />
            </Route>

            <Route path="*" element={<div />} />
        </Routes>
    );
};